export default __webpack_public_path__ + "static/media/Low at Night, High at Day.67e9f575.png";